// extracted by mini-css-extract-plugin
export default {"heroImg":"Hero_heroImg__PT0x7","subHeading":"Hero_subHeading__3Tmcf","bgColor":"Hero_bgColor__FQIOq"};